import { render, staticRenderFns } from "./BtnAtivarDesativar.vue?vue&type=template&id=5596bc0f&"
import script from "./BtnAtivarDesativar.vue?vue&type=script&lang=js&"
export * from "./BtnAtivarDesativar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports